import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  TransportManagementProfileListState,
  TransportManagementProfileListStateModel,
} from './transport-management-profile-list.state';
import {
  TransportManagementProfileListInitialState,
  TransportManagementProfileListLoad,
} from './transport-management-profile-list.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ListSearchCriteriaFacade } from '../../../list-search-criteria/list-search-criteria.facade';
import { PlannerProfile, PlannerProfileListSearchCriteria } from '../../../../models';
import { ListSearchCriteriaType } from '../../../list-search-criteria';

@Injectable({ providedIn: 'root' })
export class TransportManagementProfileListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<TransportManagementProfileListStateModel> = this.store.select(
    TransportManagementProfileListState.getState,
  );
  items$: Observable<PlannerProfile[]> = this.store.select(TransportManagementProfileListState.getItems);
  loaded$: Observable<boolean> = this.store.select(TransportManagementProfileListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.TransportManagementProfiles)
      .subscribe((searchCriteria: PlannerProfileListSearchCriteria) => {
        this.store.dispatch(new TransportManagementProfileListLoad(searchCriteria));
      });
  }

  loadListForDialog(searchCriteria: PlannerProfileListSearchCriteria): void {
    this.store.dispatch(new TransportManagementProfileListLoad(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new TransportManagementProfileListInitialState());
  }
}
